module.exports = __webpack_public_path__ + "static/media/2.c9ca1d31.png";